import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import MerTokerDetail from '@/components/active/MerTokerDetail'
import MerTokerOrder from '@/components/active/MerTokerOrder'
import MerTokerPay from '@/components/active/MerTokerPay'
import MerUnionActivity from '@/components/active/MerUnionActivity'
import MerUnionCapitalDetail from '@/components/active/MerUnionCapitalDetail'
import MerUnionConfirmeAmount from '@/components/active/MerUnionConfirmeAmount'
import MerUnionConfirmeOrder from '@/components/active/MerUnionConfirmeOrder'
import MerUnionStoreDetail from '@/components/active/MerUnionStoreDetail'
import MerUnionOrderList from '@/components/active/MerUnionOrderList'
import MerUnionOrderDetail from '../components/active/MerUnionOrderDetail'
import MerUnionmblogin from '@/components/active/member/MerUnionmblogin'
import MerUnionmbmainpage from '@/components/active/member/MerUnionmbmainpage'
import MerUnionsrCustomerAlliance from '@/components/active/store/MerUnionsrCustomerAlliance'
import MerUnionsrViewAlliance from '@/components/active/store/MerUnionsrViewAlliance'
import MerUnionmbViewAlliance from '@/components/active/member/MerUnionmbViewAlliance'
import MerUnionmbHxinformation from '@/components/active/member/MerUnionmbHxinformation'
import MerTokerCapitalDetail from '@/components/active/MerTokerCapitalDetail'
import MerTokerConfirmeAmount from '@/components/active/MerTokerConfirmeAmount'
import MerTokerLjje from '@/components/active/MerTokerLjje'
import MerTokerGetredenvelope from '@/components/active/MerTokerGetredenvelope'
import MerTokerBankcardList from '@/components/active/MerTokerBankcardList'
import MerTokerCashDetail from '@/components/active/MerTokerCashDetail'
import MerTokerAddBankCard from '@/components/active/MerTokerAddBankCard'
import MerTokerUserDetail from '@/components/active/MerTokerUserDetail'
import MerTokerMerLogin from '@/components/active/member/MerTokerMerLogin'
import MerTokerOrderUse from '@/components/active/store/MerTokerOrderUse'
import MerTokerMerIndex from '@/components/active/member/MerTokerMerIndex'
import MerUnionFansList from '../components/active/member/MerUnionFansList'
import MerTokerMerOrder from '@/components/active/member/MerTokerMerOrder'
import MerTokerMerUseInfo from '@/components/active/member/MerTokerMerUseInfo'
import MerTokerMerUserinfo from '@/components/active/member/MerTokerMerUserinfo'
import MerTokerMerUserDetail from '@/components/active/member/MerTokerMerUserDetail'
import MerUnionMerUserDetail from '@/components/active/member/MerUnionMerUserDetail'
import DeviceGoods from '../components/device/DeviceGoods'
import DeviceHome from '../components/device/DeviceHome'
import DeviceDynamic from '../components/device/DeviceDynamic'
import Earnings from '../components/device/home/Earnings'
import DeviceMy from '../components/device/DeviceMy'
import DeviceManagement from '../components/device/home/DeviceManagement'
import AccountsSet from '../components/device/userInfo/accounts/AccountsSet'
import MessageWeChat from '../components/device/userInfo/accounts/MessageWeChat'
import Security from '../components/device/userInfo/accounts/Security'
import Password from '../components/device/userInfo/accounts/Password'
import LaunchAddress from '../components/device/userInfo/accounts/LaunchAddress'
import AddressAdd from '../components/device/userInfo/accounts/AddressAdd'
import OperateRecord from '../components/device/userInfo/accounts/OperateRecord'
import Wifi from '../components/device/userInfo/accounts/Wifi'
import MemberList from '../components/device/userInfo/member/MemberList'
import MemberCount from '../components/device/userInfo/member/MemberCount'
import MemberCountDetail from '../components/device/userInfo/member/MemberCountDetail'
import MemberDetail from '../components/device/userInfo/member/MemberDetail'
import MemberBirthday from '../components/device/userInfo/member/MemberBirthday'
import AbnormalDevice from '../components/device/home/AbnormalDevice'
import StartDistribution from '../components/device/home/StartDistribution'
import DeviceParameter from '../components/device/home/DeviceParameter'
import SiteEarnings from '../components/device/home/SiteEarnings'
import SiteEarningsDetail from '../components/device/home/SiteEarningsDetail'
import EarningsDetail from '../components/device/home/EarningsDetail'
import OrderList from '../components/device/home/OrderList'
import SiteEarningsTrend from '../components/device/home/SiteEarningsTrend'
import BrandInfoSet from '../components/device/userInfo/accounts/BrandInfoSet'
import ServiceWeChat from '../components/device/userInfo/accounts/ServiceWeChat'
import BatchSelectAddress from '../components/device/userInfo/accounts/BatchSelectAddress'
import WeChatSet from '../components/device/userInfo/accounts/WeChatSet'
import ServicePhone from '../components/device/userInfo/accounts/ServicePhone'
import PhoneSet from '../components/device/userInfo/accounts/PhoneSet'
import ComplainFeedback from '../components/device/userInfo/accounts/ComplainFeedback'
import StartPageTitle from '../components/device/userInfo/accounts/StartPageTitle'
import TitleSet from '../components/device/userInfo/accounts/TitleSet'
import StartPageMsg from '../components/device/userInfo/accounts/StartPageMsg'
import MsgSet from '../components/device/userInfo/accounts/MsgSet'
import BrandName from '../components/device/userInfo/accounts/BrandName'
import GameCurrencyName from '../components/device/userInfo/accounts/GameCurrencyName'
import Banner from '../components/device/userInfo/accounts/Banner'
import BannerSet from '../components/device/userInfo/accounts/BannerSet'
import DeviceLogin from '../components/device/DeviceLogin'
import ServiceAgreement from '../components/device/ServiceAgreement'
import PayAnalysis from '../components/device/home/PayAnalysis'
import DataAnalysis from '../components/device/home/DataAnalysis'
import RechargeRuleSet from '../components/device/userInfo/accounts/RechargeRuleSet'
import Card from '../components/device/userInfo/accounts/Card'
import CardSet from '../components/device/userInfo/accounts/CardSet'
import DeviceUse from '../components/device/use/DeviceUse'
import DeviceCustom from '../components/device/use/DeviceCustom'
import DeviceYearCard from '../components/device/use/DeviceYearCard'
import DeviceRecharge from '../components/device/home/DeviceRecharge'
import DeviceRechargeRecord from '../components/device/home/DeviceRechargeRecord'
import DeviceOrderRecord from '../components/device/home/DeviceOrderRecord'
import SpreadSet from '../components/device/userInfo/accounts/SpreadSet'
import DeviceList from '../components/device/userInfo/accounts/DeviceList'
import DeviceSet from '../components/device/userInfo/accounts/DeviceSet'
import PayOk from '../components/device/common/Pay/PayOk'
import RechargeOrderList from '../components/device/home/RechargeOrderList'
import YearCardOrderList from '../components/device/home/YearCardOrderList'
import AgentSet from '../components/device/userInfo/accounts/AgentSet'
import AgentList from '../components/device/userInfo/accounts/AgentList'


Vue.use(Router)

const routes = [{
  path: '/',
  name: 'HelloWorld',
  component: HelloWorld,
  meta: {back: true}
}, {
  path: '/MerTokerDetail',
  name: 'MerTokerDetail',
  component: MerTokerDetail,
  meta: {
    back: true,
    title: '',
    keepAlive: false
  }
}, {
  path: '/MerTokerOrder',
  name: 'MerTokerOrder',
  component: MerTokerOrder,
  meta: {back: true}
}, {
  path: '/MerTokerPay',
  name: 'MerTokerPay',
  component: MerTokerPay,
  meta: {back: true}
}, {
  path: '/MerUnionActivity',
  name: 'MerUnionActivity',
  component: MerUnionActivity,
  meta: {back: true}
}, {
  path: '/MerUnionCapitalDetail',
  name: 'MerUnionCapitalDetail',
  component: MerUnionCapitalDetail,
  meta: {back: true}
}, {
  path: '/MerUnionConfirmeAmount',
  name: 'MerUnionConfirmeAmount',
  component: MerUnionConfirmeAmount,
  meta: {back: true}
}, {
  path: '/MerUnionConfirmeOrder',
  name: 'MerUnionConfirmeOrder',
  component: MerUnionConfirmeOrder,
  meta: {back: true}
}, {
  path: '/MerUnionStoreDetail',
  name: 'MerUnionStoreDetail',
  component: MerUnionStoreDetail,
  meta: {back: true}
}, {
  path: '/MerUnionOrderList',
  name: 'MerUnionOrderList',
  component: MerUnionOrderList,
  meta: {back: true}
}, {
  path: '/MerUnionOrderDetail',
  name: 'MerUnionOrderDetail',
  component: MerUnionOrderDetail,
  meta: {back: true}
}, {
  path: '/MerUnionmblogin',
  name: 'MerUnionmblogin',
  component: MerUnionmblogin,
  meta: {back: true}
}, {
  path: '/MerUnionmbmainpage',
  name: 'MerUnionmbmainpage',
  component: MerUnionmbmainpage,
  meta: {back: true}
}, {
  path: '/MerUnionsrCustomerAlliance',
  name: 'MerUnionsrCustomerAlliance',
  component: MerUnionsrCustomerAlliance,
  meta: {back: true}
}, {
  path: '/MerUnionsrViewAlliance',
  name: 'MerUnionsrViewAlliance',
  component: MerUnionsrViewAlliance,
  meta: {back: true}
}, {
  path: '/MerUnionmbViewAlliance',
  name: 'MerUnionmbViewAlliance',
  component: MerUnionmbViewAlliance,
}, {
  path: '/MerUnionmbHxinformation',
  name: 'MerUnionmbHxinformation',
  component: MerUnionmbHxinformation,
  meta: {back: true}
}, {
  path: '/MerTokerCapitalDetail',
  name: 'MerTokerCapitalDetail',
  component: MerTokerCapitalDetail,
  meta: {back: true}
}, {
  path: '/MerTokerConfirmeAmount',
  name: 'MerTokerConfirmeAmount',
  component: MerTokerConfirmeAmount,
  meta: {back: true, keepAlive: true}
}, {
  path: '/MerTokerLjje',
  name: 'MerTokerLjje',
  component: MerTokerLjje,
  meta: {back: true}
}, {
  path: '/MerTokerGetredenvelope',
  name: 'MerTokerGetredenvelope',
  component: MerTokerGetredenvelope,
  meta: {back: true}
}, {
  path: '/MerTokerBankcardList',
  name: 'MerTokerBankcardList',
  component: MerTokerBankcardList,
  meta: {back: true, keepAlive: true}
}, {
  path: '/MerTokerCashDetail',
  name: 'MerTokerCashDetail',
  component: MerTokerCashDetail,
  meta: {back: true}
}, {
  path: '/MerTokerAddBankCard',
  name: 'MerTokerAddBankCard',
  component: MerTokerAddBankCard,
  meta: {back: true, keepAlive: true}
}, {
  path: '/MerTokerUserDetail',
  name: 'MerTokerUserDetail',
  component: MerTokerUserDetail,
  meta: {back: true}
}, {
  path: '/MerTokerMerLogin',
  name: 'MerTokerMerLogin',
  component: MerTokerMerLogin,
  meta: {back: true}
}, {
  path: '/MerTokerOrderUse',
  name: 'MerTokerOrderUse',
  component: MerTokerOrderUse,
  meta: {back: true}
}, {
  path: '/MerTokerMerIndex',
  name: 'MerTokerMerIndex',
  component: MerTokerMerIndex,
  meta: {back: true}
}, {
  path: '/MerUnionFansList',
  name: 'MerUnionFansList',
  component: MerUnionFansList,
  meta: {back: true}
}, {
  path: '/MerTokerMerOrder',
  name: 'MerTokerMerOrder',
  component: MerTokerMerOrder,
  meta: {back: true}
}, {
  path: '/MerTokerMerUseInfo',
  name: 'MerTokerMerUseInfo',
  component: MerTokerMerUseInfo,
  meta: {back: true}
}, {
  path: '/MerTokerMerUserinfo',
  name: 'MerTokerMerUserinfo',
  component: MerTokerMerUserinfo,
  meta: {back: true}
}, {
  path: '/MerTokerMerUserDetail',
  name: 'MerTokerMerUserDetail',
  component: MerTokerMerUserDetail,
  meta: {back: true}
}, {
  path: '/MerUnionMerUserDetail',
  name: 'MerUnionMerUserDetail',
  component: MerUnionMerUserDetail,
  meta: {back: true}
}, {//------------device 硬件设备管理相关路由
  //device 登录
  path: '/device/login',
  name: 'DeviceLogin',
  component: DeviceLogin,
  meta: {login: false}
}, {//服务协议
  path: '/device/ServiceAgreement',
  name: 'ServiceAgreement',
  component: ServiceAgreement,
  meta: {login: false},
  props: (route) => ({type: route.query.type})
}, {//device 使用相关
  //设备使用
  path: '/device/DeviceUse',
  name: 'DeviceUse',
  component: DeviceUse,
  props: (route) => ({deviceId: route.query.deviceId})
}, {//顾客详情
  path: '/device/DeviceCustom',
  name: 'DeviceCustom',
  component: DeviceCustom
}, {//年卡开通
  path: '/device/DeviceYearCard',
  name: 'DeviceYearCard',
  component: DeviceYearCard
}, {//年卡开通
  path: '/device/PayOk',
  name: 'PayOk',
  component: PayOk,
  props: (route) => ({data: route.query.data})
}, {
  path: '/device/DeviceOrderRecord',
  name: 'DeviceOrderRecord',
  component: DeviceOrderRecord,
  meta: {login: false},
}, { //device 首页
  path: '/device/DeviceHome',
  name: 'DeviceHome',
  component: DeviceHome,
  meta: {tab: true, keepAlive: true}
}, {
  path: '/device/Earnings',
  name: 'DeviceEarnings',
  component: Earnings,
  props: (route) => ({
    startTime: route.query.startTime,
    endTime: route.query.endTime,
    home: route.query.home
  }),
  meta: {keepAlive: true}
}, {// 设备管理
  path: '/device/DeviceManagement',
  name: 'DeviceManagement',
  component: DeviceManagement,
  meta: {keepAlive: true}
}, {//异常设备
  path: '/device/AbnormalDevice',
  name: 'AbnormalDevice',
  component: AbnormalDevice,
  meta: {keepAlive: true}
}, {//启动分布
  path: '/device/StartDistribution',
  name: 'StartDistribution',
  component: StartDistribution,
  meta: {keepAlive: true}
}, {//场地收益
  path: '/device/SiteEarnings',
  name: 'SiteEarnings',
  component: SiteEarnings,
  meta: {keepAlive: true}
}, {//场地收益详情
  path: '/device/SiteEarningsDetail',
  name: 'SiteEarningsDetail',
  component: SiteEarningsDetail,
  props: (route) => ({
    addressId: route.query.addressId,
    name: route.query.name,
    deviceCount: route.query.deviceCount,
    onlinePayMoney: route.query.onlinePayMoney,
    startTime: route.query.startTime,
    endTime: route.query.endTime
  }),
  meta: {keepAlive: true}
}, {//场地收益趋势
  path: '/device/SiteEarningsTrend',
  name: 'SiteEarningsTrend',
  component: SiteEarningsTrend,
  props: (route) => ({addressId: route.query.addressId}),
  meta: {keepAlive: true}
}, {//收益详情
  path: '/device/EarningsDetail',
  name: 'EarningsDetail',
  component: EarningsDetail,
  props: (route) => ({
    deviceId: route.query.deviceId,
    startTime: route.query.startTime,
    endTime: route.query.endTime,
    tab: route.query.tab ? Number(route.query.tab) : null
  }),
  meta: {keepAlive: true}
}, {//数据分析
  path: '/device/DataAnalysis',
  name: 'DataAnalysis',
  component: DataAnalysis,
  meta: {keepAlive: true}
}, {//支付分析
  path: '/device/PayAnalysis',
  name: 'PayAnalysis',
  component: PayAnalysis,
  props: (route) => ({timeIndex: route.query.timeIndex}),
  meta: {keepAlive: true}
}, {//设备参数
  path: '/device/DeviceParameter',
  name: 'DeviceParameter',
  component: DeviceParameter
}, {//会员充值
  path: '/device/DeviceRecharge',
  name: 'DeviceRecharge',
  component: DeviceRecharge,
  meta: {keepAlive: true}
}, {//充值记录
  path: '/device/DeviceRechargeRecord',
  name: 'DeviceRechargeRecord',
  component: DeviceRechargeRecord
}, {//订单中心
  path: '/device/OrderList',
  name: 'DeviceOrderList',
  component: OrderList,
  props: (route) => ({orderId: route.query.orderId}),
  meta: {keepAlive: true}
}, {//充值订单
  path: '/device/RechargeOrderList',
  name: 'DeviceRechargeOrderList',
  component: RechargeOrderList,
  props: (route) => ({orderId: route.query.orderId}),
  meta: {keepAlive: true}
}, {//年卡订单
  path: '/device/YearCardOrderList',
  name: 'DeviceYearCardOrderList',
  component: YearCardOrderList,
  props: (route) => ({orderId: route.query.orderId}),
  meta: {keepAlive: true}
}, {//动态
  path: '/device/DeviceDynamic',
  name: 'DeviceDynamic',
  component: DeviceDynamic,
  meta: {tab: true, keepAlive: true}
}, {//我的
  path: '/device/DeviceMy',
  name: 'DeviceMy',
  component: DeviceMy,
  meta: {tab: true, keepAlive: true}
}, {//套餐页面
  path: '/device/DeviceGoods',
  name: 'DeviceGoods',
  component: DeviceGoods
}, {
  path: '/device/AccountsSet',
  name: 'AccountsSet',
  component: AccountsSet
}, {
  path: '/device/MessageWeChat',
  name: 'MessageWeChat',
  component: MessageWeChat
}, {
  path: '/device/Security',
  name: 'Security',
  component: Security
}, {
  path: '/device/Password',
  name: 'Password',
  component: Password
}, {
  path: '/device/LaunchAddress',
  name: 'LaunchAddress',
  component: LaunchAddress,
  meta: {keepAlive: true},
  props: (route) => ({data: route.query.data})
}, {
  path: '/device/AddressAdd',
  name: 'AddressAdd',
  component: AddressAdd,
  meta: {keepAlive: true},
  props: (route) => ({data: route.query.data})
}, {
  path: '/device/OperateRecord',
  name: 'OperateRecord',
  component: OperateRecord
}, {
  path: '/device/Wifi',
  name: 'Wifi',
  component: Wifi
}, {
  path: '/device/MemberList',
  name: 'MemberList',
  component: MemberList
}, {
  path: '/device/MemberCount',
  name: 'MemberCount',
  component: MemberCount
}, {
  path: '/device/MemberCountDetail',
  name: 'MemberCountDetail',
  component: MemberCountDetail
}, {
  path: '/device/MemberDetail',
  name: 'MemberDetail',
  component: MemberDetail,
  props: (route) => ({uid: route.query.uid})
}, {
  path: '/device/MemberBirthday',
  name: 'MemberBirthday',
  component: MemberBirthday
}, {
  path: '/device/BrandInfoSet',
  name: 'BrandInfoSet',
  component: BrandInfoSet
}, {
  path: '/device/ServiceWeChat',
  name: 'ServiceWeChat',
  component: ServiceWeChat
}, {
  path: '/device/BatchSelectAddress',
  name: 'BatchSelectAddress',
  component: BatchSelectAddress,
  props: (route) => ({type: route.query.type})
}, {
  path: '/device/WeChatSet',
  name: 'WeChatSet',
  component: WeChatSet,
  props: (route) => ({type: route.query.type, data: route.query.data})
}, {
  path: '/device/ServicePhone',
  name: 'ServicePhone',
  component: ServicePhone
}, {
  path: '/device/PhoneSet',
  name: 'PhoneSet',
  component: PhoneSet,
  props: (route) => ({type: route.query.type, data: route.query.data})
}, {
  path: '/device/ComplainFeedback',
  name: 'ComplainFeedback',
  component: ComplainFeedback
}, {
  path: '/device/StartPageTitle',
  name: 'StartPageTitle',
  component: StartPageTitle
}, {
  path: '/device/TitleSet',
  name: 'TitleSet',
  component: TitleSet,
  props: (route) => ({type: route.query.type, data: route.query.data})
}, {
  path: '/device/StartPageMsg',
  name: 'StartPageMsg',
  component: StartPageMsg
}, {
  path: '/device/MsgSet',
  name: 'MsgSet',
  component: MsgSet,
  props: (route) => ({type: route.query.type, data: route.query.data})
}, {
  path: '/device/BrandName',
  name: 'BrandName',
  component: BrandName
}, {
  path: '/device/GameCurrencyName',
  name: 'GameCurrencyName',
  component: GameCurrencyName
}, {
  path: '/device/Banner',
  name: 'Banner',
  component: Banner
}, {
  path: '/device/BannerSet',
  name: 'BannerSet',
  component: BannerSet
}, {
  path: '/device/RechargeRuleSet',
  name: 'RechargeRuleSet',
  component: RechargeRuleSet
}, {
  path: '/device/Card',
  name: 'Card',
  component: Card,
}, {
  path: '/device/CardSet',
  name: 'CardSet',
  component: CardSet,
  props: (route) => ({data: route.query.data})
}, {
  path: '/device/SpreadSet',
  name: 'SpreadSet',
  component: SpreadSet
}, {
  path: '/device/DeviceList',
  name: 'DeviceList',
  component: DeviceList,
  props: (route) => ({addressId: route.query.addressId})
}, {
  path: '/device/DeviceSet',
  name: 'DeviceSet',
  component: DeviceSet,
  props: (route) => ({data: route.query.data})
}, {
  path: '/device/AgentList',
  name: 'AgentList',
  component: AgentList
}, {
  path: '/device/AgentSet',
  name: 'AgentSet',
  component: AgentSet,
  props: (route) => ({data: route.query.data})
}]

const router = new Router({
  mode: 'history',
  base: '/',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js